<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-16 10:00:25
 * @LastEditors: may.li
 * @LastEditTime: 2023-05-17 09:19:07
-->
<template>
<div class="page_shop">
    <div class="datalist">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadGoodsList">
			<ul class="list">
				<li class="item" v-for="(goods,index) in dataList" :key="index" @click="goShopDetail(goods)">
					<div class="thumb">
						<van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="goods.thumb" />
					</div>
					<div class="item_xinxi">
						<div class="title_wrap single">
							<span class="title title3 slh_s">{{ goods.title }}</span>
						</div>
						<div class="info">
							<span class="f-l price">¥{{ goods.price }}</span>
						</div>
					</div>
				</li>
			</ul>
		</van-list>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
			token: null,
			companyId: 3,
			page: 1,
			size: 10,
			dataList: [],
			loading: false,
			finished: false,
        }
    },
    created() {
		
    },
    methods: {
		/**
		 * @name: 获取商品列表
		 * @return {*}
		 * @desc: 
		 */		
		loadGoodsList(){
			let params = {
				company_id: this.companyId,
				page: this.page,
				size: this.size
			};
			this.$api.thirdshop.good(params).then(res=>{
				if(res.code == 200){
					let list = res.result;
					if(list && list.length){
						for(let i in list){
							this.dataList.push(list[i])
						};
						if(list.length < this.size){
							this.finished = true;
						}else{
							this.loading = false;
							this.page++;
						}
					}else{
						this.finished = true;
					}
				}else{
					this.finished = true;
				}
			})
		},
		/**
		 * @name: 跳转详情
		 * @param {*} goods
		 * @return {*}
		 * @desc: 
		 */		
		goShopDetail(goods){
			this.$router.push({
				path: '/third/goods',
				query: {
					companyId: this.companyId,
					goodsId: goods.good_id
				}
			})
		}
    },
}
</script>
<style scoped>
	.datalist{
		padding-top: .4rem;
	}
</style>
